import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const n = o("n-upload");
export {
  n as uploadInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/interface.js
// module id = 219
// module chunks = 67